import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResearchAuthService } from 'research.oidc.angular';

@Component({
  template: `<res-login (loginCallback)="login()"></res-login>`

})
export class LoginComponent implements OnInit {


  constructor(private router: Router, private auth: ResearchAuthService) {
  }

  public login(): void {
    this.auth.login();
  }

  ngOnInit() {
    if (this.auth.userClaimsExist()) {
      this.router.navigate([this.auth.afterLoginRoute]);
    }
  }

}




// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/login/login.component.ts